export interface Article {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  publishDate: string;
  author: string;
  tag: string;
  relatedMovieId: string;
  readMinutes: number;
}

export const articles: Article[] = [
  {
    id: "a1",
    title: "《光影边缘》深度解析：父亲留下的胶片，是一封迟到的道歉信",
    excerpt:
      "从一卷未冲洗的胶片，到一场露天放映的落幕，影片用极其克制的镜头，讲述了两代人之间那场迟到太久的和解。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20still%20of%20a%20vintage%20film%20camera%20and%20unrolled%20photographic%20negative%20on%20a%20wooden%20table%20beside%20a%20rainy%20window%20deep%20blue%20shadows%20and%20warm%20amber%20light%20film%20grain%20no%20text&width=800&height=600&seq=article-a1-cover&orientation=landscape",
    publishDate: "2024-09-18",
    author: "编辑部",
    tag: "剧情解析",
    relatedMovieId: "m1",
    readMinutes: 8,
  },
  {
    id: "a2",
    title: "《深巷谜案》为什么能成为年度悬疑天花板？聊聊它的叙事诡计",
    excerpt:
      "一条即将拆迁的老巷，一只被摆正的怀表。剧集用近乎仪式感的细节，把观众一步步引入人心最幽深的角落。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20narrow%20old%20alley%20at%20night%20with%20red%20lanterns%20and%20drifting%20fog%20deep%20blue%20shadows%20and%20warm%20glow%20mysterious%20atmosphere%20no%20text&width=800&height=600&seq=article-a2-cover&orientation=landscape",
    publishDate: "2024-09-27",
    author: "影评人 白鲸",
    tag: "剧集综述",
    relatedMovieId: "t1",
    readMinutes: 10,
  },
  {
    id: "a3",
    title: "《星海孤帆》视听美学：孤独在宇宙尺度下是什么形状",
    excerpt:
      "极简的场景与极致的视觉想象，影片把「孤独」拍成了一种可以被看见、被听见、甚至被触摸的东西。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20lone%20spacecraft%20drifting%20past%20a%20giant%20glowing%20ringed%20planet%20in%20deep%20space%20with%20dense%20stars%20and%20blue%20nebula%20sense%20of%20solitude%20no%20text&width=800&height=600&seq=article-a3-cover&orientation=landscape",
    publishDate: "2024-09-25",
    author: "编辑部",
    tag: "视听分析",
    relatedMovieId: "m3",
    readMinutes: 7,
  },
  {
    id: "a4",
    title: "从《平行来信》看平行世界题材：逻辑自洽有多重要",
    excerpt:
      "两个世界的通信，一次次改变着命运的走向。剧集最难得的，是在烧脑设定之下始终没有丢掉情感的温度。",
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20cinematic%20still%20of%20two%20mirrored%20rainy%20city%20streets%20split%20by%20a%20glowing%20seam%20of%20light%20deep%20teal%20and%20cold%20blue%20palette%20no%20text&width=800&height=600&seq=article-a4-cover&orientation=landscape",
    publishDate: "2024-08-22",
    author: "影评人 沈砚",
    tag: "题材观察",
    relatedMovieId: "t4",
    readMinutes: 9,
  },
  {
    id: "a5",
    title: "《记忆碎片馆》角色分析：当一个人开始怀疑自己的记忆",
    excerpt:
      "如果记忆可以被借阅和修复，那么「我是谁」这个问题，还有谁能给出确定的答案？",
    cover:
      "https://readdy.ai/api/search-image?query=Surreal%20cinematic%20still%20of%20floating%20glowing%20memory%20fragments%20and%20photographs%20in%20a%20deep%20teal%20dreamlike%20void%20soft%20volumetric%20light%20no%20text&width=800&height=600&seq=article-a5-cover&orientation=landscape",
    publishDate: "2024-09-08",
    author: "影评人 白鲸",
    tag: "角色分析",
    relatedMovieId: "m6",
    readMinutes: 6,
  },
  {
    id: "a6",
    title: "《火焰之城》里的城市隐喻：有人要烧掉的从来不只是建筑",
    excerpt:
      "一场场精准的纵火，指向的是十年前被掩盖的事故。剧集把复仇拍成了一座城市的集体记忆。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20night%20city%20skyline%20with%20orange%20fire%20glow%20and%20thick%20smoke%20against%20a%20deep%20blue%20sky%20dramatic%20atmosphere%20no%20text&width=800&height=600&seq=article-a6-cover&orientation=landscape",
    publishDate: "2024-09-30",
    author: "编辑部",
    tag: "剧情解析",
    relatedMovieId: "t7",
    readMinutes: 8,
  },
];